






























import { Vue, Component, Ref } from 'vue-property-decorator';
import { FitHalfScreenDialog } from '@tencent/wphk-ui';
import MerchantItemInfo from '@/components/we-coupons/merchant-item-info.vue';
import { MerchantInfo } from '@tencent/wphk-components-wecoupon';
import MchCouponList from '@tencent/wphk-components-wecoupon/components/mch-coupon-list/index.vue';
import { NotifyActionRet } from '@/business/we-coupons/coupon-subscribe';
import { removeWecouponAdFlag, setWecouponAdFlag } from '@/business/we-coupons/ad';
import { MerchantInfoWithAd, ReceivedCouponListType } from '@/types/we-coupons';
import { i18n } from '@/i18n';
import { initShare } from '@/views/WeCoupons/utils/view-helper';

@Component({
  components: {
    MerchantItemInfo,
    FitHalfScreenDialog,
    MchCouponList,
  },
})
export default class MerchantDialog extends Vue {
  i18n = i18n;
  @Ref('dialog') halfScreenDialog;
  @Ref('mchCouponList') mchCouponList!: MchCouponList;

  merchantInfo!: MerchantInfo;
  show = false;

  // 是否来时广告位启动的弹窗
  isFromAd = false;

  async showDialog(info: MerchantInfoWithAd) {
    if (info.isFromAd && info.dpId) {
      this.isFromAd = true;
      // 设置广告标识
      setWecouponAdFlag(String(info.dpId));
    }
    this.merchantInfo = info;
    (this.$refs.mchCouponList as MchCouponList)?.init();
    this.show = true;
  }

  hideDialog() {
    // 清除广告标识
    removeWecouponAdFlag();
    this.isFromAd = false;
    // 关闭弹窗
    this.show = false;
    this.$emit('close');
    initShare(); // 目前设置的是Channel页分享，这里重置回抢券有so的分享
  }

  getCouponAction(result: NotifyActionRet) {
    if (this.isFromAd) {
      // 渠道批量领取的券couponId列表
      let receivedCouponList: ReceivedCouponListType = [];
      const ret = result?.data?.result;
      if (ret?.couponId) {
        receivedCouponList = [{ couponId: ret.couponId, userScid: ret.userScid }];
      } else if (ret?.result?.length) {
        receivedCouponList = ret.result.map(ele => ({ couponId: ele.couponId, userScid: ele.userScid }));
      }
      this.$emit('adGetCoupon', receivedCouponList);
    }
    this.$emit('showSubscribeDialog', result);
  }
}
